import React from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

export default function BoxInputs({
  box,
  index,
  errors,
  showAdvanced,
  handleBoxChange,
  addBox,
  deleteBox,
  boxesLength,
}) {

    // Function to prevent negative values
  const preventNegative = (e) => {
    if (e.key === '-' || e.key === 'e') {
      e.preventDefault();
    }
  };
  return (
    <div className="border border-indigo-300 rounded-2xl p-5 md:p-6 space-y-4 relative bg-white transition-all">
      <div className="grid grid-cols-1 md:grid-cols-6 gap-6 items-start text-black">
        {/* Inputs Section */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 col-span-5">
          {/* Quantity */}
          {showAdvanced && (
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-600 mb-1">
                Quantity
              </label>
              <input
                type="number"
                min="0"
                placeholder=""
                value={box.noOfBoxes}
                onChange={(e) =>
                  handleBoxChange(index, "noOfBoxes", e.target.value)
                }
                onKeyDown={preventNegative}
                className={`border px-3 py-2 rounded-md text-sm placeholder:text-xs focus:outline-none focus:ring-2 transition ${
                  errors?.noOfBoxes
                    ? "border-red-500 focus:ring-red-300"
                    : "border-gray-300 focus:ring-indigo-300"
                }`}
              />
              {errors?.noOfBoxes && (
                <p className="text-blue-500 text-xs mt-1">{errors.noOfBoxes}</p>
              )}
            </div>
          )}

          {/* Weight per Box */}
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 whitespace-nowrap">
              Wt/box (kg)
            </label>
            <input
              type="number"
              min="0"
              placeholder=""
              value={box.Weightperbox}
              onChange={(e) =>
                handleBoxChange(index, "Weightperbox", e.target.value)
              }
              onKeyDown={preventNegative}
              className={`border px-3 py-2 rounded-md text-sm placeholder:text-xs focus:outline-none focus:ring-2 transition ${
                errors?.Weightperbox
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-indigo-300"
              }`}
            />
            {errors?.Weightperbox && (
              <p className="text-blue-500 text-xs mt-1">
                {errors.Weightperbox}
              </p>
            )}
          </div>

          {/* Length */}
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 whitespace-nowrap">
              Length (Cm)
            </label>
            <input
              type="number"
              min="0"
              placeholder=""
              value={box.length}
              onChange={(e) => handleBoxChange(index, "length", e.target.value)}
              onKeyDown={preventNegative}
              className={`border px-3 py-2 rounded-md text-sm placeholder:text-xs focus:outline-none focus:ring-2 transition ${
                errors?.length
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-indigo-300"
              }`}
            />
            {errors?.length && (
              <p className="text-blue-500 text-xs mt-1">{errors.length}</p>
            )}
          </div>

          {/* Width */}
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 whitespace-nowrap">
              Width (Cm)
            </label>
            <input
              type="number"
              min="0"
              placeholder=""
              value={box.width}
              onChange={(e) => handleBoxChange(index, "width", e.target.value)}
              onKeyDown={preventNegative}
              className={`border px-3 py-2 rounded-md text-sm placeholder:text-xs focus:outline-none focus:ring-2 transition ${
                errors?.width
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-indigo-300"
              }`}
            />
            {errors?.width && (
              <p className="text-blue-500 text-xs mt-1">{errors.width}</p>
            )}
          </div>

          {/* Height */}
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 whitespace-nowrap">
              Height (Cm)
            </label>
            <input
              type="number"
              min="0"
              placeholder=""
              value={box.height}
              onChange={(e) => handleBoxChange(index, "height", e.target.value)}
              onKeyDown={preventNegative}
              className={`border px-3 py-2 rounded-md text-sm placeholder:text-xs focus:outline-none focus:ring-2 transition ${
                errors?.height
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-indigo-300"
              }`}
            />
            {errors?.height && (
              <p className="text-blue-500 text-xs mt-1">{errors.height}</p>
            )}
          </div>
        </div>
        {/* Action Buttons */}
        <div className="flex items-center gap-4 justify-start md:justify-end mt-2 md:mt-6">
          <button
            type="button"
            onClick={addBox}
            className="p-2 rounded-full bg-green-100 text-green-700 hover:bg-green-200 transition"
          >
            <FaPlus className="w-4 h-4" />
          </button>
          {boxesLength > 1 && (
            <button
              type="button"
              onClick={() => deleteBox(index)}
              className="text-red-600 hover:text-red-800 text-lg"
            >
              <FaTrash />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
